(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order"] && !Shopify.designMode) return;
  try {
    
function initCustomOrder(){
 const preview=document.getElementById('CustomOrder-stole-preview');
 const base=document.getElementById('CustomOrder-base-color');
 const ink=document.getElementById('CustomOrder-text-color');
 const symbolColor=document.getElementById('CustomOrder-symbol-color');
 const stripeStyle=document.getElementById('CustomOrder-stripe-style');
 const stripeColors=document.getElementById('CustomOrder-stripe-colors');
 const symbol=document.getElementById('CustomOrder-symbol');
 const neckSymbol=document.getElementById('CustomOrder-neck-symbol');
 const left=document.getElementById('CustomOrder-left');
 const right=document.getElementById('CustomOrder-right');
 const stripes=[1,2,3].map(i=>document.getElementById('CustomOrder-stripe-'+i));
 const previewCard=preview&&preview.closest('.us-live-preview');
 const previewDialog=document.getElementById('CustomOrder-preview-dialog');
 const previewStage=document.getElementById('CustomOrder-preview-stage');
 const expandPreview=document.getElementById('CustomOrder-expand-preview');
 if(previewCard&&previewDialog&&expandPreview&&!expandPreview.dataset.previewBound){
  expandPreview.dataset.previewBound='true';
  previewCard.classList.add('us-mobile-preview-enabled');
  expandPreview.addEventListener('click',()=>{
   document.getElementById('CustomOrder-expanded-preview').appendChild(preview);
   previewDialog.showModal();
  });
  previewDialog.addEventListener('close',()=>{previewStage.appendChild(preview);});
  document.getElementById('CustomOrder-close-preview').addEventListener('click',()=>previewDialog.close());
  let previewPositionPending=false;
  function updatePreviewPosition(){
   previewPositionPending=false;
   let top=0;
   for(const header of document.querySelectorAll('header,[role="banner"],header-component')){
    const position=getComputedStyle(header).position;
    const rect=header.getBoundingClientRect();
    if((position==='sticky'||position==='fixed')&&rect.top<=1&&rect.bottom>0&&rect.height<200)top=Math.max(top,rect.bottom);
   }
   previewCard.style.setProperty('--us-mobile-preview-top',top+'px');
  }
  function schedulePreviewPosition(){if(!previewPositionPending){previewPositionPending=true;requestAnimationFrame(updatePreviewPosition);}}
  window.addEventListener('scroll',schedulePreviewPosition,{passive:true});
  window.addEventListener('resize',schedulePreviewPosition,{passive:true});
  updatePreviewPosition();
 }
 if(preview&&base&&!base.dataset.previewBound){
  base.dataset.previewBound='true';
  function renderPanel(group,input){
   group.replaceChildren();
   const raw=input.value.trim();
   input.setCustomValidity('');
   if(!raw){const warning=document.getElementById('CustomOrder-wording-error');warning.hidden=!document.getElementById('CustomOrder-left').validationMessage&&!document.getElementById('CustomOrder-right').validationMessage;return;}
   let lines=[];
   for(const paragraph of raw.split(/\r?\n/)){
    let line='';
    for(const word of paragraph.trim().split(/\s+/)){
     if((line+' '+word).trim().length>12&&line){lines.push(line);line='';}
     line+=(line?' ':'')+word;
    }
    if(line)lines.push(line);
   }
   if(!lines.length)return;
   const tooMany=lines.length>4;
   input.setCustomValidity(tooMany?input.dataset.lineError:'');
   const warning=document.getElementById('CustomOrder-wording-error');
   warning.hidden=!document.getElementById('CustomOrder-left').validationMessage&&!document.getElementById('CustomOrder-right').validationMessage;
   lines=lines.slice(0,4);
   const maxChars=Math.max(...lines.map(v=>v.length));
   const size=Math.min(48,190/(maxChars*.65),350/lines.length);
   const lineHeight=Math.min(75,350/lines.length);
   for(let i=0;i<lines.length;i++){
    const node=document.createElementNS('http://www.w3.org/2000/svg','text');
    node.setAttribute('x','0');node.setAttribute('y',String((i-(lines.length-1)/2)*lineHeight+size*0.35));
    node.setAttribute('font-size',String(size));node.setAttribute('font-family','Georgia, serif');
    node.setAttribute('font-weight','600');node.textContent=lines[i];group.appendChild(node);
   }
  }
  function updateStole(){
   function tint(filterId,color){
 const rgb=[1,3,5].map(i=>parseInt(color.slice(i,i+2),16)/255);
 const filter=preview.querySelector('#'+filterId);
 ['r','g','b'].forEach((channel,i)=>{
  const func=filter.querySelector('.us-tint-'+channel);
  if(color.toLowerCase()==='#171717'){func.setAttribute('slope','1');func.setAttribute('intercept','0');}
  else{func.setAttribute('slope',String(rgb[i]*2.1));func.setAttribute('intercept',String(rgb[i]*0.58));}
 });
}
tint('us-base-tint',base.value);
   const leftGroup=document.getElementById('CustomOrder-preview-left-text');
   const rightGroup=document.getElementById('CustomOrder-preview-right-text');
   leftGroup.setAttribute('fill',ink.value);rightGroup.setAttribute('fill',ink.value);
   renderPanel(leftGroup,left);renderPanel(rightGroup,right);
   stripeColors.hidden=false;
   for(const control of stripes)control.disabled=false;
   document.getElementById('CustomOrder-preview-stripes').style.display='';
   const stripeNames=['one','two','three'];
   stripes.forEach((control,i)=>tint('us-stripe-'+stripeNames[i]+'-tint',control.value));
   document.getElementById('CustomOrder-preview-symbols').style.color=symbolColor.value;
   document.getElementById('CustomOrder-stool-ink').setAttribute('flood-color',symbolColor.value);
   preview.querySelector('.us-preview-key').style.display=symbol.value==='Key'?'':'none';
   preview.querySelector('.us-preview-stool').style.display=symbol.value==='Stool'?'':'none';
   preview.querySelectorAll('.us-preview-key use').forEach((node,i)=>{
    node.setAttribute('transform','translate('+(i===0?332:688)+' '+460.5+')');
   });
   preview.querySelectorAll('.us-preview-stool use').forEach((node,i)=>{
    node.setAttribute('transform','translate('+(i===0?332:688)+' '+460.5+')');
   });
  }
  for(const control of [base,ink,symbolColor,stripeStyle,symbol,neckSymbol,left,right,...stripes])control.addEventListener('input',updateStole);
  updateStole();
 }

 const quantity=document.getElementById('CustomOrder-quantity');
 const estimate=document.getElementById('CustomOrder-estimate');
 const arrival=document.getElementById('CustomOrder-arrival');
 const note=document.getElementById('CustomOrder-deadline');
 if(quantity&&estimate&&!quantity.dataset.estimateBound){
  quantity.dataset.estimateBound='true';
  quantity.addEventListener('input',()=>{
   const count=Number(quantity.value);
   if(!quantity.value||!quantity.validity.valid||!Number.isInteger(count)){estimate.textContent=estimate.dataset.empty;return;}
   const cents=count<=10?2495:count<=30?2395:count<=40?2295:2195;
   estimate.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(count*cents/100);
  });
 }
 if(arrival&&note&&!arrival.dataset.dateBound){
  arrival.dataset.dateBound='true';
  const today=new Date();today.setHours(0,0,0,0);
  arrival.min=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
  arrival.addEventListener('input',()=>{
   const requested=new Date(arrival.value+'T00:00:00');
   note.hidden=!arrival.value||!arrival.validity.valid||(requested-today)/86400000>=42;
  });
 }
 const checkout=document.getElementById('CustomOrder-checkout');
 const form=document.getElementById('CustomOrderForm');
 const additional=document.getElementById('CustomOrder-additional');
 if(form&&additional&&!additional.dataset.validationBound){
  additional.dataset.validationBound='true';
  form.addEventListener('invalid',event=>{if(additional.contains(event.target))additional.open=true;},true);
 }
 if(checkout&&form&&!checkout.dataset.checkoutBound){
  checkout.dataset.checkoutBound='true';checkout.disabled=false;
  const error=document.getElementById('CustomOrder-checkout-error');
  const acknowledge=document.getElementById('CustomOrder-checkout-ack');
  let pending=null;
  function showError(message){error.textContent=message;error.hidden=false;error.focus();}
  checkout.addEventListener('click',async()=>{
   if(checkout.disabled)return;
   error.hidden=true;
   if(!form.reportValidity())return;
   if(document.getElementById('CustomOrder-reference').value.trim()||document.getElementById('CustomOrder-colors').value.trim()){showError(checkout.dataset.special);return;}
   const today=new Date();today.setHours(0,0,0,0);
   if((new Date(arrival.value+'T00:00:00')-today)/86400000<28){showError(checkout.dataset.urgent);return;}
   if(!acknowledge.checked){showError(checkout.dataset.ack);acknowledge.focus();return;}
   const properties={
    'Base color':base.value,'Lettering color':ink.value,'Symbol color':symbolColor.value,
    'Stripe style':'Three stripes','Upper symbols — below first stripes':symbol.value,
    'Neck symbols (matching pair)':neckSymbol.value,
    "Wearer's left wording":left.value.trim()||'None',
    "Wearer's right wording":right.value.trim()||'None',
    'Requested arrival date':arrival.value,
    'Delivery destination':document.getElementById('CustomOrder-destination').value.trim(),
    'Design notes':document.getElementById('CustomOrder-notes').value.trim(),
    'Organization':document.getElementById('CustomOrder-organization').value.trim(),
    'Order acknowledgement':'Design reviewed; final sale; production averages 4–6 weeks; arrival date requires confirmation'
   };
   properties['Center stripe']=stripes[0].value;properties['Inner stripes']=stripes[1].value;properties['Outer stripes']=stripes[2].value;
   const count=Number(quantity.value);
   const signature=JSON.stringify({quantity:count,properties});
   if(!pending||pending.signature!==signature)pending={signature,id:Date.now().toString(36)+'-'+Math.random().toString(36).slice(2)};
   properties['_design_session']=pending.id;
   const label=checkout.textContent;
   const quoteButton=form.querySelector('button[type="submit"]');
   checkout.disabled=true;quoteButton.disabled=true;checkout.textContent=checkout.dataset.busy;form.setAttribute('aria-busy','true');
   const root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
   try{
    const cartResponse=await fetch(root+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'});
    if(!cartResponse.ok)throw new Error();
    const cart=await cartResponse.json();
    const existing=cart.items.find(item=>String(item.variant_id)===checkout.dataset.variant&&item.properties&&item.properties['_design_session']===pending.id);
    if(!existing){
     const response=await fetch(root+'cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',
      body:JSON.stringify({items:[{id:Number(checkout.dataset.variant),quantity:count,properties}]})
     });
     if(!response.ok)throw new Error();
     await response.json();
    }
    window.location.assign(root+'checkout');
   }catch(problem){
    showError(checkout.dataset.error);checkout.disabled=false;quoteButton.disabled=false;checkout.textContent=label;form.removeAttribute('aria-busy');
   }
  });
 }

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCustomOrder);}else{initCustomOrder();}
document.addEventListener('shopify:section:load',initCustomOrder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
